<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {useProductName} from "@/composables/useProductName";
import {ref} from 'vue'

export default {
  name: "TotalPriceOfProducts",
  data() {
    return {
      store,
      priceProducts: {
        spravniPoplatek: {}
      }
    }
  },
  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const {productName} = useProductName()
    const select = ref(0)
    const lang = locale;
    return {t, select, lang, productName}
  },
  computed: {

    getSpravniPoplatek() {
      var prod = this.store.getOrderProduct('ZU01');
      // console.log(prod);
      this.priceProducts.spravniPoplatek = prod;
      return prod;
    },
    getSeatProduct() {
      return this.store.getSeatProduct();
    },
    seatSelected() {
      return this.store.order.products.some(product => product.type === 'seat');
    },
    zmenaSidlaSelected() {
      return (this.store.form.mamIco === 'mam'
              && this.store.form.osoba === 'fyzicka'
              && this.store.form.vyrizeniZmenySidla)

          || (
              this.store.form.mamIco === 'mam'
              && this.store.form.osoba === 'pravnicka'
              && this.store.form.vyrizeniZmenySidla
              && (this.store.form.sidloVeSmlouve === 'nevim'
                  || this.store.form.sidloVeSmlouve === 'konkretniAdresa')

              || (
                  this.store.form.mamIco === 'mam'
                  && this.store.form.osoba === 'pravnicka'
                  && this.store.form.vyrizeniZmenySidla
                  && this.store.form.sidloVeSmlouve === 'obec'
                  && this.store.form.adresaSidlaJe !== ''
              )
          );
    }
  }

}
</script>

<template>

  <table class="table table-borderless table-sm tableTotalPriceOfProducts">
    <tr v-if="seatSelected">
      <td class="font-weight-bold" colspan="20">{{ t('total.virtualSeat') }}:</td>
    </tr>
    <tr v-if="seatSelected">
      <td class="check " style="width: 10px;"><i class="fa fa-check text-secondary"></i></td>
      <td>{{ t('sidla.' + store.getSeatProduct()[0].codeForTran).split('–')[0] }} {{ t('na') }}
        {{ t('years.m' + store.getSeatProduct()[0].months) }}
        <span v-if="getSeatProduct[0].months === '12' && getSeatProduct[0].firstYearWebDiscountPercent" class="badge badge-secondary rounded">
            <s>{{getSeatProduct[0].totalPriceWithoutVatNoSaleFilter}}</s> | {{t('sale')}} {{getSeatProduct[0].firstYearWebDiscountPercent}} % {{t('na')}} 1. {{t('year')}}
         </span>
      </td>
      <td class="text-secondary text-right">{{store.priceFilter(store.getSeatProduct()[0].totalPriceWithoutVat)}}</td>
    </tr>
    <tr v-if="!seatSelected">
      <td colspan="20">{{ t('total.zvolteSidlo') }}</td>
    </tr>

    <tr v-if="zmenaSidlaSelected"
        class="font-weight-bold">
      <td colspan="20" class="pt-3">{{ t('total.zmenaSidla') }}:</td>
    </tr>

    <tr v-if="zmenaSidlaSelected"
        v-for="product in store.order.products"
        class="">
      <td v-if="!product.type || (product.type && product.type !== 'seat')" class="check " style="width: 10px;"><i
          class="fa fa-check text-secondary"></i></td>
      <td v-if="!product.type || (product.type && product.type !== 'seat')">{{ productName(product) }}</td>
      <td v-if="(!product.type || (product.type && product.type !== 'seat'))"
          class="text-right text-secondary text-nowrap">{{ store.priceFilter(product.totalPriceWithoutVat) }} </td>
    </tr>

    <tr v-if="zmenaSidlaSelected && store.form.osoba === 'pravnicka' && store.form.sidloVeSmlouve === 'nevim'">
      <td class="check " style="width: 10px;"><i class="fa fa-check text-secondary"></i></td>
      <td>{{ t('total.products.nevim') }}</td>
    </tr>

  </table>
</template>

<style lang="scss" scoped>
.price {

}

.nameType {

}

.tableTotalPriceOfProducts {
  td {
    font-size: 14px;
  }
}
</style>